import axios from 'axios'
import { apiEndPoints, serverAPIUrl, serverTopUpCode, isUsingOwnUploadingServer, customUploadImageDomain, imgbbApiKey } from './api-config'
// topUpServerAPIUrl
import { clearUserData, getToken, saveTokens } from './storage-helper'

const getUserMaintenanceEndPoint = type => {
  switch (type) {
    case 'USERNAME':
      return apiEndPoints.changeUsername
    case 'PASSWORD':
      return apiEndPoints.changePassword
    case 'PINCODE':
      return apiEndPoints.changePinCode
    case 'EMAIL':
      return apiEndPoints.changeEmail
    case 'GAMETIME_GAMEPOINTS':
      return apiEndPoints.convertGameTimeToGamePoints
    case 'FORGOT_PIN_CODE':
      return apiEndPoints.forgotPinCode
    case 'FORGOT_CHARPIN':
      return apiEndPoints.forgotCharPin
    case 'FORGOT_PASSWORD':
      return apiEndPoints.forgotPassword
    case 'RESET_PASSWORD':
      return apiEndPoints.resetPassword
    case 'REGISTER':
      return apiEndPoints.registerUser
    case 'PILOT_MODE':
      return apiEndPoints.updatePilotMode
    case 'CHARPIN':
        return apiEndPoints.changeCharPin
    default:
      return null
  }
}
export const forgotValuablePin = async (param, setAuthentication) => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.forgotValuablePin

  try {
    const result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        message: result.data.message || result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }

    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors:
          data.response.data?.error ||
          [data.response.data?.message] ||
          ['Unable to send Valuable PIN.']
      }
    }

    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['Forgot Valuable PIN endpoint was not found.']
      }
    }

    return {
      success: false,
      status: data.response.status,
      errors: [
        data.response.data?.message ||
          'Unable to send Valuable PIN. Please try again.'
      ]
    }
  }

  return null
}

export const changeValuablePin = async (param, setAuthentication) => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.changeValuablePin

  try {
    const result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        message: result.data.message || result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }

    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors:
          data.response.data?.error ||
          [data.response.data?.message] ||
          ['Unable to change Valuable PIN.']
      }
    }

    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['Change Valuable PIN endpoint was not found.']
      }
    }

    return {
      success: false,
      status: data.response.status,
      errors: [
        data.response.data?.message ||
          'Unable to change Valuable PIN. Please try again.'
      ]
    }
  }

  return null
}
export const createWhitelist = async (param, setAuthentication) => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getWhitelists

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }
}

export const getWhitelists = async setAuthentication => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getWhitelists

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const uploadImageToImgBB = async (param) => {
  if (isUsingOwnUploadingServer) {
    // If isUsingOwnUploadingServer is true, try uploading to your custom server
    if (!param.file) return null;

    const formData = new FormData();
    formData.append('file', param.file);

    try {
      const res = await axios.post(
        `${customUploadImageDomain}/upload.php`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: false,
        }
      );

      console.log('UPLOAD RESPONSE:', res.data);

      if (res.data?.success) {
        return res.data.url; // Return URL if custom server upload was successful
      }
      return null; // Return null if custom server upload fails
    } catch (error) {
      // If there's an error with the custom server, log the error and move to ImgBB
      console.error('UPLOAD ERROR DATA:', error.response?.data);
      console.error('UPLOAD ERROR STATUS:', error.response?.status);
      console.error('UPLOAD ERROR MSG:', error.message);
      
      // Proceed to ImgBB fallback
      return fallbackToImgBB(param);
    }
  } else {
    // If isUsingOwnUploadingServer is false, immediately fallback to ImgBB
    return fallbackToImgBB(param);
  }
};

// Fallback to ImgBB if custom server upload fails or is skipped
const fallbackToImgBB = async (param) => {
  const endPoint = 'https://api.imgbb.com/1/upload';
  const apiKey = imgbbApiKey; // Replace with your actual ImgBB API key

  const formData = new FormData();
  formData.append('key', apiKey);
  formData.append('image', param.file);

  try {
    axios.defaults.withCredentials = false;
    const result = await axios.post(endPoint, formData, {
      headers: { Accept: 'application/json' },
    });

    if (result.status === 200) {
      return result.data.data.url; // Return ImgBB URL if upload is successful
    } else {
      return null; // Return null if ImgBB upload fails
    }
  } catch (error) {
    console.log('ImgBB Upload Error:', error);
    return null; // Handle any ImgBB upload failure
  }
};

export const replyTicket = async (param, setAuthentication) => {
  let endPoint = serverAPIUrl + apiEndPoints.requestTicket + '/reply'

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(endPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      if (setAuthentication === undefined || setAuthentication === null)
        window.location.reload(false)
      else setAuthentication(false)
      return null
    }
  }
}

export const getTicketById = async (param /*, setAuthentication*/) => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.requestTicket + '/' + param.id

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      // if(setAuthentication=== undefined || setAuthentication === null)
      //     window.location.reload(false)
      // else
      //     setAuthentication(false)

      return null
    }
  }

  return null
}

export const createTicket = async (param, setAuthentication) => {
  let formData = new FormData()
  //formData.append("file", param.file);
  formData.append('referenceNumber', param.referenceNumber)
  formData.append('message', param.message)
  formData.append('amount', Number(param.amount))
  formData.append('fileName', param.fileName)
  formData.append('captchaToken', param.captchaToken)

  let endPoint = serverAPIUrl + apiEndPoints.requestTicket

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(endPoint, formData, {
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${getToken()}`
      }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }
}

export const getTickets = async (param, setAuthentication) => {
  if (param === undefined) param = 1

  let apiEndPoint = serverAPIUrl + apiEndPoints.getTickets + '/' + param

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const shopBuyItem = async (param, setAuthentication) => {
  let endPoint = serverAPIUrl + apiEndPoints.shopBuyItem + param.id

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(endPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }
}

export const getShopItems = async (param, pageNumber, setAuthentication) => {
  let apiEndPoint =
    serverAPIUrl +
    apiEndPoints.getShopItems +
    'type/' +
    param.typeId +
    '/category/' +
    param.categoryId +
    '/' +
    pageNumber

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const getShopRecords = async (param, setAuthentication) => {
  if (param === undefined) param = 1

  let apiEndPoint = serverAPIUrl + apiEndPoints.getShopRecords + param

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      // var refreshTokenRequest = await refreshJWTToken();
      // if(refreshTokenRequest) {
      //     var requestAgain = await getShopRecords(setAuthentication)
      //     return requestAgain;
      // }else{
      //     setAuthentication(false)
      //     resetUserLocalData()
      //     return null;
      // }
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const getTopupRecords = async (param, setAuthentication) => {
  if (param === undefined) param = 1

  let apiEndPoint = serverAPIUrl + apiEndPoints.getTopupRecords + param

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const requestTopup = async param => {
  let constructEndPoint = `${param.id}`
  param.serverCode = serverTopUpCode
  let endPoint = serverAPIUrl + apiEndPoints.requestTopup + constructEndPoint

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(endPoint, param, { withCredentials: true })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: [
          'There is a problem while processing your request. Please try again later.'
        ],
        status: 404
      }
    }
  }
}

export const topUpCheckOut = async param => {
  //let apiEndPoint = topUpServerAPIUrl + apiEndPoints.topUpCheckOut + param.id + '/' + serverTopUpCode;
  let apiEndPoint = serverAPIUrl + apiEndPoints.topUpCheckOut + param.id

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === undefined || data.response === null) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        status: 404
      }
    }
  }

  return null
}

export const userMaintenance = async (type, param, setAuthentication) => {
  const endPoint = getUserMaintenanceEndPoint(type)

  try {
    axios.defaults.withCredentials = true
    var result = await axios.post(serverAPIUrl + endPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      // update token.
      if (type === 'EMAIL' || type === 'USERNAME') {
        saveTokens(result.data.data)
      }
      return {
        success: true,
        data: result.data.data
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 400) {
      return {
        success: false,
        errors: data.response.data.error,
        status: 400
      }
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        errors: ['There is a problem while processing your request.'],
        status: 404
      }
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }
}

export const requestLogout = async setAuthentication => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.requestLogout

  try {
    var result = await axios.post(
      apiEndPoint,
      {},
      {
        withCredentials: true,
        headers: { Authorization: `Bearer ${getToken()}` }
      }
    )

    if (result.status === 200) {
      clearUserData()
      setAuthentication(false)
      return true
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return {
        success: true,
        status: 401
      }
    }
  }

  return false
}

export const getUserGameTime = async setAuthentication => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getUserGameTime

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const getUserAccountInfo = async setAuthentication => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getUserAccountInfo

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const getUserBasicInfo = async setAuthentication => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getUserBasicInfo

  try {
    var result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === null || data.response === undefined) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const getNewsById = async param => {
  let apiEndPoint = serverAPIUrl + apiEndPoints.getNewsById + param.id

  try {
    var result = await axios.get(apiEndPoint)

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    var data = { ...error }

    if (data.response === undefined || data.response === null) {
      return null
    }

    if (data !== null && data !== undefined && data.response.status === 404) {
      return {
        success: false,
        status: 404
      }
    }
  }

  return null
}

export const getRankings = async param => {
  let constructEndPoint = `/type/${param.type}/class/${param.class}/school/${param.school}`

  let apiEndPoint = serverAPIUrl + apiEndPoints.getRankings + constructEndPoint

  var result = await fetch(apiEndPoint)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getPremiumPoints = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getPremiumPoints)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getDownloads = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getDownloads)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getNews = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getNews)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getIndividualRankings = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getindividualRankings)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getTopSpenderRankings = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getTopSpenderRankings)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const getElectronicRoomsInfo = async () => {
  var result = await fetch(serverAPIUrl + apiEndPoints.getElectronicRoomsInfo)

  if (result.status === 200) {
    var data = await result.json()
    return data
  }

  return null
}

export const convertReferralPointsToEPoints = async (
  pinCode,
  setAuthentication
) => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.convertReferralPointsToEPoints;

  try {
    const result = await axios.post(
      apiEndPoint,
      { pinCode },
      {
        withCredentials: true,
        headers: { Authorization: `Bearer ${getToken()}` }
      }
    );

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      };
    }
  } catch (error) {
    const data = { ...error };

    if (!data?.response) return null;

    if (data.response.status === 401) {
      clearUserData();
      setAuthentication(false);
      return null;
    }

    // Handle 400 (Bad Request) like Register API
    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors: data.response.data?.error || [data.response.data?.message] || ['Something went wrong.']
      };
    }

    // Handle 404
    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['The requested resource was not found.']
      };
    }

    // fallback for other errors
    return {
      success: false,
      status: data.response.status,
      errors: [data.response.data?.message || 'Something went wrong.']
    };
  }

  return null;
};



// const refreshJWTToken = async ()  => {
//     let apiEndPoint = serverAPIUrl + apiEndPoints.requestRefreshToken;

//     try{
//         axios.defaults.withCredentials = true
//         var result = await axios.post(apiEndPoint, { withCredentials: true})

//         if(result.status === 200){
//             return true;
//         }
//     }catch(error) {
//         return false;
//     }

//     return false;
// }

/*--- Verified Services ---*/

// Public. Returns the four tab groups with their members and rating summaries.
export const getVerifiedServices = async () => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.getVerifiedServices

  try {
    const result = await axios.get(apiEndPoint)

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    return null
  }

  return null
}

// Ratings the signed in player has already left, keyed by member id on the client.
export const getMyCommunityRatings = async setAuthentication => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.getMyCommunityRatings

  try {
    const result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const rateVerifiedService = async (param, setAuthentication) => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.rateVerifiedService

  try {
    const result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }

    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors: data.response.data?.error || ['Unable to save your rating.']
      }
    }

    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['Unable to save your rating.']
      }
    }
  }

  return null
}

export const getMyVerifiedServiceProfiles = async setAuthentication => {
  const apiEndPoint = serverAPIUrl + apiEndPoints.getMyVerifiedServiceProfiles

  try {
    const result = await axios.get(apiEndPoint, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }
  }

  return null
}

export const updateMyVerifiedServiceProfile = async (
  param,
  setAuthentication
) => {
  const apiEndPoint =
    serverAPIUrl + apiEndPoints.updateMyVerifiedServiceProfile

  try {
    const result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }

    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors: data.response.data?.error || ['Unable to save your profile.']
      }
    }

    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['Unable to save your profile.']
      }
    }
  }

  return null
}

// One click availability toggle for a member's own profile.
export const updateMyVerifiedServiceAvailability = async (
  param,
  setAuthentication
) => {
  const apiEndPoint =
    serverAPIUrl + apiEndPoints.updateMyVerifiedServiceAvailability

  try {
    const result = await axios.post(apiEndPoint, param, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${getToken()}` }
    })

    if (result.status === 200) {
      return {
        success: true,
        data: result.data.data,
        status: 200
      }
    }
  } catch (error) {
    const data = { ...error }

    if (!data?.response) return null

    if (data.response.status === 401) {
      clearUserData()
      setAuthentication(false)
      return null
    }

    if (data.response.status === 400) {
      return {
        success: false,
        status: 400,
        errors:
          data.response.data?.error || ['Unable to update your availability.']
      }
    }

    if (data.response.status === 404) {
      return {
        success: false,
        status: 404,
        errors: ['Unable to update your availability.']
      }
    }
  }

  return null
}
